// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';

export const StyledDamImage = styled(DamImage)`
  &.espot-promo-dam {
    height: 100%;
    width: 100%;
    ${(props) =>
      props.tileHeightValue
        ? `height: ${props.tileHeightValue - props.tileBadgeHeightValue}px;`
        : ''}
  }
`;

export const StyledESpotPromoTile = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  ${(props) => (props.tileBadgeHeightValue ? `padding-top: ${props.tileBadgeHeightValue}px;` : '')}
  max-height: 400px;
  @media ${(props) => props.theme.mediaQuery.large} {
    max-height: 500px;
  }
  picture {
    width: 100%;
  }
`;
